import css from "./DemoProjects.sass?inline"
import {Html} from "@opendaw/lib-dom"
import {Lifecycle} from "@opendaw/lib-std"
import {createElement} from "@opendaw/lib-jsx"
import {Colors} from "@opendaw/studio-enums"
import {StudioService} from "@/service/StudioService"
import {DemoProjectJson} from "@/ui/dashboard/DemoProjectJson"
import {DemoProject} from "@/ui/dashboard/DemoProject"

const className = Html.adoptStyleSheet(css, "DemoProjects")

type Construct = {
    lifecycle: Lifecycle
    service: StudioService
}

const NewProjectJson: DemoProjectJson = {
    id: "",
    hasCover: false,
    bundleSize: 0,
    metadata: {
        name: "New Project",
        artist: "MusicFlow",
        description: "",
        tags: ["clean slate"],
        created: "",
        modified: "",
        coverMimeType: ""
    }
}


export const DemoProjects = ({service}: Construct) => (
    <div className={className}>
        <h3 style={{color: Colors.purple.toString()}}>Start</h3>
        <div className="projects">
            <DemoProject json={NewProjectJson} load={async () => {
                await service.newProject()
                import("@opendaw/lib-jsx").then(({RouteLocation}) => RouteLocation.get().navigateTo("/studio"))
            }}/>
        </div>
    </div>
)